import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, catchError, tap } from 'rxjs';
// import { RoleDTO, RoleVTO, RoleListRS } from './role-service.model';
import { ErrorService } from '../error/error-service';
import { AuthService } from '../auth-service';
import { RoleDTO, RolesDTO } from '../../pages/admin-dashboard/user-management/user-management.model';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.userMgtApiUrl;
  private baseUrl = `${this.API}/roles`;

  // createRole(payload: RoleDTO): Observable<RoleVTO> {
  //   const token = this.authService.getAccessToken();
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }
  //   return this.http.post<RoleVTO>(this.baseUrl, payload, { headers }).pipe(
  //     tap(() => console.log('Role created successfully')),
  //     catchError(ErrorService.handleError),
  //   );
  // }

  getAllRoles(): Observable<RolesDTO> {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<RolesDTO>(this.baseUrl, { headers }).pipe(
      tap(() => console.log('Roles retrieved successfully')),
      catchError(ErrorService.handleError),
    );
  }

  // getRoleById(id: number): Observable<RoleVTO> {
  //   const token = this.authService.getAccessToken();
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }
  //   return this.http.get<RoleVTO>(`${this.baseUrl}/${id}`, { headers }).pipe(
  //     tap(() => console.log(`Role with ID ${id} retrieved successfully`)),
  //     catchError(ErrorService.handleError),
  //   );
  // }

  // updateRole(id: number, payload: RoleDTO): Observable<void> {
  //   const token = this.authService.getAccessToken();
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }
  //   return this.http.put<void>(`${this.baseUrl}/${id}`, payload, { headers }).pipe(
  //     tap(() => console.log(`Role with ID ${id} updated successfully`)),
  //     catchError(ErrorService.handleError),
  //   );
  // }

  // deleteRole(id: number): Observable<void> {
  //   const token = this.authService.getAccessToken();
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }
  //   return this.http.delete<void>(`${this.baseUrl}/${id}`, { headers }).pipe(
  //     tap(() => console.log(`Role with ID ${id} deleted successfully`)),
  //     catchError(ErrorService.handleError),
  //   );
  // }

  // updateRoleScopes(roleId: number, scopeIds: number[]): Observable<void> {
  //   const token = this.authService.getAccessToken();
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }
  //   return this.http.put<void>(`${this.baseUrl}/${roleId}/scopes`, { scopeIds }, { headers }).pipe(
  //     tap(() => console.log(`Scopes for role ID ${roleId} updated successfully`)),
  //     catchError(ErrorService.handleError),
  //   );
  // }
}
